import React from 'react';
import { getComponentClasses } from '../../utils/app';
import { Icon } from '../Icon';

interface Props {
    href: string;
    variations?: string[];
    icon: React.ReactElement<Icon>;
    children: React.ReactNode;
}

export default class LinkWithIcon extends React.Component<Props> {
    getLinkChildren() {
        return [
            <span className="link-with-icon__icon" key="icon">
                {this.props.icon}
            </span>,
            <span className="link-with-icon__label" key="label">
                {this.props.children}
            </span>,
        ];
    }

    render() {
        const classes = getComponentClasses('link-with-icon', this.props.variations);
        const { variations, icon, ...props } = this.props;
        return (
            <a {...props} className={classes}>
                {this.getLinkChildren()}
            </a>
        );
    }
}
